import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

/**
 * The split's in-flight pick: `{ splitTime, workOrderOperationRef, destination }`,
 * or null. `destination` is null until the operator picks a job.
 */
export const getLaborTicketSplitDraft = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.laborTicketSplitDraft;
  }
);
